import type { EligibleCartProduct } from '@jane/shared/models';
import { Flex } from '@jane/shared/reefer';
import type {
  PendingCartProduct,
  QualifyingStatusEnum,
} from '@jane/shared/types';

import { SpecialDetailStatusCTA } from '../specialDetailStatusCTA/specialDetailStatusCTA';
import { ProductRow } from './productRow';
import type { ProductRowProps } from './productRow';

export interface SpecialDetailStatusBundleProgressProps {
  // conditions.settings.allow_discounts_on_required_products OR special_type === "buy_x_and_save"
  allowQualifiersToBeDiscounted: boolean;
  calloutSubtext?: string;
  calloutText?: string;
  discountedProducts: PendingCartProduct[];
  isGold: boolean;
  onRemoveProduct: ProductRowProps['onRemoveProduct'];
  qualifiedProducts: PendingCartProduct[];
  qualifyingStatus: QualifyingStatusEnum;
  tagLabel: string;
}

export const SpecialDetailStatusBundleProgress = ({
  allowQualifiersToBeDiscounted,
  calloutSubtext,
  calloutText,
  discountedProducts,
  isGold,
  onRemoveProduct,
  qualifiedProducts,
  qualifyingStatus,
  tagLabel,
}: SpecialDetailStatusBundleProgressProps) => {
  const isApplied = qualifyingStatus === 'applied';
  const isQualified = qualifyingStatus === 'qualified';
  const isUnlocked = isQualified || isApplied;

  const qualifiedProductsToRender: EligibleCartProduct[] =
    qualifiedProducts.flatMap((product) => Array(product.count).fill(product));

  const discountedProductsToRender: EligibleCartProduct[] =
    discountedProducts.flatMap((product) => Array(product.count).fill(product));

  return (
    <Flex flexDirection="column" gap={16} p={24}>
      {qualifiedProductsToRender.map((product, i) => (
        <ProductRow
          key={`${product.id}-${i}`}
          isDiscounted={allowQualifiersToBeDiscounted}
          isGold={isGold}
          isUnlocked={isUnlocked}
          onRemoveProduct={onRemoveProduct}
          product={product}
          tagLabel={tagLabel}
        />
      ))}

      {isUnlocked &&
        discountedProductsToRender.map((product, i) => (
          <ProductRow
            key={`${product.id}-${i}`}
            isDiscounted
            isGold
            isUnlocked
            onRemoveProduct={onRemoveProduct}
            product={product}
            tagLabel={tagLabel}
          />
        ))}

      {calloutText && (
        <SpecialDetailStatusCTA
          calloutSubtext={calloutSubtext}
          calloutText={calloutText}
          isGold={isGold}
        />
      )}
    </Flex>
  );
};
